module.exports = __webpack_public_path__ + "img/edgardo-suarez-byn.6a61288a.jpg";